import { useState } from 'react';
import { siteImageCandidates } from '../../../shared/domain/siteImages.js';

const text = (value) => String(value ?? '').trim();

export function NikkePortraitImage({
  src = '',
  alt = '',
  fallbackText = '?',
  fallbackClassName = '',
  loading = 'lazy',
  fetchPriority = 'auto',
}) {
  // Our WebP copy first; if it ever fails, the original URL before the text fallback.
  const candidates = siteImageCandidates(src);
  const [failedSources, setFailedSources] = useState([]);
  const visibleSource = candidates.find((source) => !failedSources.includes(source)) || '';

  if (!visibleSource) {
    return <span className={fallbackClassName}>{text(fallbackText) || '?'}</span>;
  }

  return (
    <img
      src={visibleSource}
      alt={alt}
      loading={loading}
      fetchPriority={fetchPriority}
      decoding="async"
      onError={() => setFailedSources((current) => (current.includes(visibleSource) ? current : [...current, visibleSource]))}
    />
  );
}
